import { render, staticRenderFns } from "./VendorDetail.vue?vue&type=template&id=9ef269b0&"
import script from "./VendorDetail.vue?vue&type=script&lang=js&"
export * from "./VendorDetail.vue?vue&type=script&lang=js&"
import style0 from "./VendorDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports